import { Duration } from 'date-fns';

export const getDurationEoD = (): Duration => {
    const now = new Date();
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    return {
        hours: endOfDay.getHours() - now.getHours(),
        minutes: endOfDay.getMinutes() - now.getMinutes(),
    };
};
